import { TCheckedType } from 'pages/common/types';

type TGetIsCheckedProducts = {
  checkedProducts: [] | TCheckedType;
  productId: string;
};

export const getIsCheckedProducts = ({ checkedProducts, productId }: TGetIsCheckedProducts) =>
  checkedProducts.find(item => item.id === productId)?.isChecked;
